/** @jsx h */
const Tags = ({
  date,
  datetime,
  categories,
  dates,
  sessionHours,
  duration,
  typeOfLearning,
  subtitle,
}) => {
  return (
    <ul className="tags">
      {date && datetime && (
        <li className="tags_tag label-grey">
          <time dateTime={datetime}>{date}</time>
        </li>
      )}
      {dates && (
        <li className="tags_tag label-grey">
          <span>{dates}</span>
        </li>
      )}
      {categories?.length &&
        categories.map((category, index) => {
          return (
            <li className="tags__tag label-bold" key={index}>
              <span>{category}</span>
            </li>
          );
        })}
      {sessionHours && (
        <li className="tags_tag label-grey">
          <span>{sessionHours}</span>
        </li>
      )}
      {duration && (
        <li className="tags_tag label-grey label-grey--dark">
          <span>{duration}</span>
        </li>
      )}
      {typeOfLearning && (
        <li className="tags_tag label-bold">
          <span>{typeOfLearning}</span>
        </li>
      )}
      {subtitle && (
        <li className="tags_tag label-bold">
          <span>{subtitle}</span>
        </li>
      )}
    </ul>
  );
};

export default Tags;
